var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3102 15.0965H38.7881C45.0694 15.0965 50.1673 20.3465 50.1673 26.7865V39.6665C50.1673 46.1065 45.0694 51.3332 38.7881 51.3332H17.2132C10.9319 51.3332 5.83398 46.1065 5.83398 39.6665V26.7865C5.83398 20.3465 10.9319 15.0965 17.2132 15.0965H17.6911C17.7366 12.2965 18.8063 9.68317 20.7407 7.72317C22.6979 5.73984 25.2014 4.7365 28.0234 4.6665C33.6675 4.6665 38.2419 9.33317 38.3102 15.0965ZM23.1304 10.2198C21.8559 11.5265 21.1504 13.2532 21.1049 15.0965H34.8964C34.8282 11.2698 31.7785 8.1665 28.0234 8.1665C26.271 8.1665 24.4503 8.88984 23.1304 10.2198ZM36.6488 24.0798C37.6047 24.0798 38.3557 23.2865 38.3557 22.3298V19.6232C38.3557 18.6665 37.6047 17.8732 36.6488 17.8732C35.7157 17.8732 34.942 18.6665 34.942 19.6232V22.3298C34.942 23.2865 35.7157 24.0798 36.6488 24.0798ZM20.8545 22.3298C20.8545 23.2865 20.1035 24.0798 19.1476 24.0798C18.2145 24.0798 17.4408 23.2865 17.4408 22.3298V19.6232C17.4408 18.6665 18.2145 17.8732 19.1476 17.8732C20.1035 17.8732 20.8545 18.6665 20.8545 19.6232V22.3298Z",
    fill: "#D1D7E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.ef7e4396.svg";
export { ForwardRef as ReactComponent };